import React from 'react';

interface Step {
    label: string;
}

interface StepperProps {
    steps: Step[];
    currentStep: number; // 1-based index
}

const Stepper: React.FC<StepperProps> = ({ steps, currentStep }) => {
    return (
        <div className="d-flex gap-5px align-items-center">
            {steps.map((step, index) => {
                const stepNumber = index + 1;
                const isActive = stepNumber === currentStep;
                const isCompleted = stepNumber < currentStep;

                return (
                    <div
                        key={stepNumber}
                        className="d-flex gap-5px align-items-center"
                    >
                        {/* Step button */}
                        <div
                            className={`px-10px py-8px radius-5px d-flex flex-column flex-md-row gap-10px align-items-center text-center text-md-start
                ${
                    isActive
                        ? 'bg-medium-blue'
                        : isCompleted
                          ? 'bg-medium-blue'
                          : 'bg-light-blue'
                }`}
                        >
                            <span
                                className={`rounded-circle min-w-20px h-20px border border-2px border-black text-black d-flex align-items-center justify-content-center fs-12px fw-bold text-center
                  ${isActive || isCompleted ? '' : ''}`}
                            >
                                {isCompleted ? (
                                    <svg
                                        width="11"
                                        height="9"
                                        viewBox="0 0 11 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M10.3683 1.13327C10.5445 1.31036 10.5438 1.59679 10.3667 1.77303L4.45751 7.65398C4.28102 7.82962 3.99577 7.82962 3.81928 7.65398L1.13327 4.98082C0.956178 4.80457 0.955492 4.51814 1.13173 4.34105C1.30798 4.16397 1.59441 4.16328 1.77149 4.33952L4.13839 6.6951L9.72851 1.13173C9.90559 0.955492 10.192 0.956178 10.3683 1.13327Z"
                                            fill="black"
                                            stroke="black"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    stepNumber
                                )}
                            </span>
                            <div className="fs-12px fs-md-16px text-black text-nowrap">
                                {step.label}
                            </div>
                        </div>

                        {/* Line separator (except last step) */}
                        {index < steps.length - 1 && (
                            <div
                                className={`w-20px min-h-2px ${
                                    stepNumber < currentStep
                                        ? 'bg-black'
                                        : 'bg-grey-3'
                                }`}
                            ></div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default Stepper;
